import { PlatformEnum } from "@/types/modular-permissions.types";

export const platformNameResolver = (platform: PlatformEnum) => {
  switch (platform) {
    case PlatformEnum.Twitter:
      return "Twitter";
    case PlatformEnum.Instagram:
      return "Instagram";
    case PlatformEnum.Telegram:
      return "Telegram";
  }
};
